function formatEventDate(dateString, endEventDateString) {
    const startDate = new Date(dateString);
    if (Number.isNaN(startDate.getTime())) return '';

    function getOrdinalSuffix(day) {
        const lastTwoDigits = day % 100;
        if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th';

        const lastDigit = day % 10;
        if (lastDigit === 1) return 'st';
        if (lastDigit === 2) return 'nd';
        if (lastDigit === 3) return 'rd';
        return 'th';
    }

    function formatTime(date) {
        const hours24 = date.getHours();
        const minutes = date.getMinutes();
        const meridiem = hours24 >= 12 ? 'PM' : 'AM';
        const hours12 = (hours24 % 12) || 12;

        if (minutes === 0) {
            return `${hours12}${meridiem}`;
        }

        return `${hours12}:${String(minutes).padStart(2, '0')}${meridiem}`;
    }

    if (!endEventDateString) {
        const weekday = startDate.toLocaleString('en-US', { weekday: 'short' });
        const month = startDate.toLocaleString('en-US', { month: 'short' });
        const day = startDate.getDate();
        return `${weekday}, ${month} ${day}${getOrdinalSuffix(day)}, ${formatTime(startDate)}`;
    }

    const endDate = new Date(endEventDateString);
    if (Number.isNaN(endDate.getTime())) {
        const weekday = startDate.toLocaleString('en-US', { weekday: 'short' });
        const month = startDate.toLocaleString('en-US', { month: 'short' });
        const day = startDate.getDate();
        return `${weekday}, ${month} ${day}${getOrdinalSuffix(day)}, ${formatTime(startDate)}`;
    }

    const sameCalendarDay =
        startDate.getFullYear() === endDate.getFullYear()
        && startDate.getMonth() === endDate.getMonth()
        && startDate.getDate() === endDate.getDate();

    if (sameCalendarDay) {
        const weekday = startDate.toLocaleString('en-US', { weekday: 'short' });
        const month = startDate.toLocaleString('en-US', { month: 'short' });
        const day = startDate.getDate();
        return `${weekday}, ${month} ${day}${getOrdinalSuffix(day)}, ${formatTime(startDate)}-${formatTime(endDate)}`;
    }

    const startMonth = startDate.toLocaleString('en-US', { month: 'long' });
    const endMonth = endDate.toLocaleString('en-US', { month: 'long' });
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();

    if (startYear === endYear && startMonth === endMonth) {
        return `${startMonth} ${startDay} - ${endDay}, ${startYear}`;
    }

    if (startYear === endYear) {
        return `${startMonth} ${startDay} - ${endMonth} ${endDay}, ${startYear}`;
    }

    return `${startMonth} ${startDay}, ${startYear} - ${endMonth} ${endDay}, ${endYear}`;
}